import mapValues from 'lodash/mapValues';

/** provides the look-and-feel of an image display on a product item view */
export const getSquareImage = (
  $container: JQuery<HTMLImageElement>,
  productImage: MerchantosProductImageModel | null
) => {
  if (productImage) {
    const imgWidth = $container.width();

    if (imgWidth) {
      $container.attr(
        'src',
        productImage.getResizedUrl({
          format: 'jpg',
          crop: 'fill',
          width: imgWidth,
          height: imgWidth, // make the image square
        })
      );
    }
  }
};

export const parseImageUsage = (usage: ImageUsage) => {
  const {
    defaultMaxImageCount,
    defaultMaxTotalImageSize,
    totalImageSize,
    imageCountHardLimitReached,
    imageCountSoftLimitReached,
    imageCount,
    totalImageSizeHardLimitReached,
    totalImageSizeSoftLimitReached,
  } = usage;

  const booleans = {
    totalImageSizeHardLimitReached,
    totalImageSizeSoftLimitReached,
    imageCountHardLimitReached,
    imageCountSoftLimitReached,
  };

  const integers = { imageCount, defaultMaxImageCount, defaultMaxTotalImageSize, totalImageSize };

  return {
    ...booleans,
    ...mapValues(integers, value => parseInt(value, 10)),
  };
};
